module.exports = __webpack_public_path__ + "img/brushes-cn-5.98faf99.jpg";